import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import Mq from '../util/mq'

export default class MobileNav {
  constructor($el) {
    this.$el = $($el)
    this.scrollingSection = this.$el.find('.c-mobile-nav__inner')[0]
    this.activeClass = 'is-mobile-nav-open'

    const $navlink = this.$el.find('.c-mobile-nav__list a')
    const $trigger = $('.js-mobile-nav-trigger')

    $trigger.on('click', e => {
      e.preventDefault()

      if ($('html').hasClass(this.activeClass)) {
        this.closeNav()
      } else {
        this.openNav()
      }
    })

    Mq.atLeast('--site-nav-breakpoint', e => {
      if (e.matches) {
        this.closeNav()
        this.closeSubNav($navlink, $navlink)
      }
    })

    $navlink.next('ul').hide()
    $navlink.on('click', e => {
      if ($(e.currentTarget).next('ul').length) {
        e.preventDefault()
        if (
          !$(e.currentTarget)
            .parent()
            .hasClass('is-open')
        ) {
          this.openSubNav(e.currentTarget, $navlink)
        } else {
          this.closeSubNav(e.currentTarget, $navlink)
        }
      }
    })
  }

  openSubNav($el, $links) {
    $links.parent().removeClass('is-open')
    $links.next('ul').slideUp(200)

    $($el)
      .parent()
      .addClass('is-open')
    $($el)
      .next('ul')
      .slideDown(200)
  }

  closeSubNav($el, $links) {
    $($el)
      .parent()
      .removeClass('is-open')

    $links.next('ul').slideUp(200)
  }

  openNav() {
    $('html').addClass(this.activeClass)
    disableBodyScroll(this.scrollingSection)
  }

  closeNav() {
    $('html').removeClass(this.activeClass)
    enableBodyScroll(this.scrollingSection)
  }
}
